import { createModule } from 'saga-slice';
import { sagaApi } from '#/apis';
import { loadingReducer, failReducer } from 'saga-slice-helpers';
import { put } from 'redux-saga/effects';
import Swal from '#/swal';

const sagaSlice = createModule({

    name: 'orders',
    initialState: {
        isFetching: false,
        data: null,
        notInEntrata: null,
        entrataDown: null,
        error: null
    },

    reducers: {
        getAmenities: loadingReducer,
        getAmenitiesSuccess: (state, payload) => {


            state.data = (payload.inEntrata || []).reduce((acc, curr) => {

                if (acc[curr.unit_space_name]) {
                    acc[curr.unit_space_name].push(curr);
                }
                else {
                    acc[curr.unit_space_name] = [curr];
                }

                return acc;
            }, {});

            state.notInEntrata = payload.notInEntrata;

            state.entrataDown = (payload.entrataDown || []).reduce((acc, curr) => {

                if (acc[curr.unit_space_name]) {
                    acc[curr.unit_space_name].push(curr);
                }
                else {
                    acc[curr.unit_space_name] = [curr];
                }

                return acc;
            }, {});

            state.isFetching = false;
        },

        addNotes: loadingReducer,
        addNotesSuccess: (state, payload) => {
            state.isFetching = false;
        },

        deleteAmenityNote: loadingReducer,
        deleteAmenityNoteSuccess: (state, payload) => {
            state.isFetching = false;
        },


        fail: failReducer
    },

    sagas: A => ({
        [A.getAmenities]: function* ({ payload: property_id }) {

            yield sagaApi.get(`/properties/${property_id}/amenities`, A.getAmenitiesSuccess, A.fail);
        },

        [A.addNotes]: function* ({ payload }) {

            yield sagaApi.put('/amenity-notes', payload, A.addNotesSuccess, A.fail);
        },
        [A.addNotesSuccess]: function* ({ payload }) {

            yield put(A.getAmenities(payload.property_id));
        },
        [A.deleteAmenityNote]: function* ({ payload }) {

            const { value } = yield Swal.fire.warning();

            if (value) {
                yield sagaApi.post('/amenity-notes/delete', payload, A.deleteAmenityNoteSuccess, A.fail);
                yield put(A.getAmenities(payload.property_id));
            }

            yield put(A.deleteAmenityNoteSuccess());

        }
    })
});

// Export actions for convenience when importing from other modules
export const { actions } = sagaSlice;
export default sagaSlice;
